import React from 'react';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { CUSTOMERS_TABLE_ROW_HEIGHT } from '@finance-hub/domain/customers/components/customers-table-columns';
import { FinanceHubCustomerRow } from '@finance-hub/domain/customers/blocs/types/customer-list';
import { Pressable } from 'react-native';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';

interface Props {
  row: Row<FinanceHubCustomerRow>;
}

export const CustomersTableRow = React.memo<Props>(({ row }) => {
  const [styles] = useStyles();

  return (
    <Pressable style={styles.row} tabIndex={-1}>
      {({ hovered }) => (
        <TableRow
          index={row.index}
          style={{ minHeight: CUSTOMERS_TABLE_ROW_HEIGHT }}
        >
          {row
            .getVisibleCells()
            .map((cell: Cell<FinanceHubCustomerRow, unknown>) => (
              <TableCell
                cell={cell}
                key={cell.id}
                style={hovered ? styles.hovered : undefined}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            ))}
        </TableRow>
      )}
    </Pressable>
  );
});

CustomersTableRow.displayName = 'CustomersTableRow';

const useStyles = createStyles((theme) => ({
  hovered: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  row: {
    cursor: 'auto',
  },
}));
